/**
 * Session-change cache reset (T885) — the upgrade-window half.
 *
 * Under the current worker no cache holds an identity (`.data` is never cached; a document
 * rendered with a session is never written). A device still controlled by a pre-T885 worker
 * keeps writing `LEGACY_CACHES` until the new worker activates (no automatic `skipWaiting`,
 * contract §4); this deletes them whenever the root loader's identity changes between two
 * renders of the page, so a client-side sign-out does not leave them behind meanwhile.
 *
 * Pure apart from the `CacheStorage` it is handed.
 */

import { LEGACY_CACHES } from "./cache-policy";

/**
 * `previous` is `undefined` on the first render: a page load is not a session change, and
 * purging there would empty the offline documents on every visit.
 */
export function identityChanged(
  previous: string | null | undefined,
  next: string | null,
): boolean {
  return previous !== undefined && previous !== next;
}

/** Deletes the legacy identity caches. No Cache API (SSR, old browsers) → nothing to do. */
export async function purgeSessionCaches(
  cacheStorage: Pick<CacheStorage, "delete"> | undefined,
): Promise<void> {
  if (!cacheStorage) return;
  // A failed delete leaves the cache as it was; the next identity change retries it.
  await Promise.allSettled(LEGACY_CACHES.map((name) => cacheStorage.delete(name)));
}
